import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { CandidatesAddressType } from './candidates-address-type.interface';

export class CandidatesAddressTypeService {
   async getCandidatesAddressTypes() {
      const response = await http.get<ApiResource<Array<CandidatesAddressType>>>(`/address-types`, {
         ...cacheFirstConfig,
      });
      return response.data;
   }

   async getCandidatesAddressType() {
      throw Error('Method not implemented');
   }

   async postCandidatesAddressType() {
      throw Error('Method not implemented');
   }

   async putCandidatesAddressType() {
      throw Error('Method not implemented');
   }

   async deleteCandidatesAddressType() {
      throw Error('Method not implemented');
   }
}
